// 将相对路径补全为完整资源地址
export function resolveMediaUrl(path) {
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  return 'https://aqjt365.cn/uploads/' + path.replace(/^\/+/, '')
}

// 秒数 -> mm:ss 或 hh:mm:ss
export function formatTime(seconds) {
  seconds = Math.floor(Number(seconds) || 0)
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = seconds % 60
  const pad = n => (n < 10 ? '0' + n : '' + n)
  if (h > 0) return `${pad(h)}:${pad(m)}:${pad(s)}`
  return `${pad(m)}:${pad(s)}`
}

// 兼容 "00:21:05" 字符串与秒数
export function formatDuration(value) {
  if (value === null || value === undefined || value === '') return ''
  const str = String(value)
  if (str.indexOf(':') > -1) return str
  const seconds = parseFloat(str)
  if (isNaN(seconds)) return str
  return formatTime(seconds)
}
